export * from "@/ui/components/primitives/Skeleton/Skeleton";
export * from "@/ui/components/primitives/Skeleton/Skeleton.config";
